import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/** Renders its children only for a signed-in user; everyone else goes to /login. */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-100 text-sm text-foreground-500">
        <i className="ri-loader-4-line mr-2 animate-spin" />
        Loading your workspace…
      </div>
    );
  }
  if (status === 'signedOut') {
    return <Navigate to="/login?as=agency" replace state={{ from: location.pathname + location.search }} />;
  }
  // A temporary password must be changed before anything else (Laravel's CpaaSAuthenticate).
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}
